// extracted by mini-css-extract-plugin
var _1 = "ra-quiz-page-active";
var _2 = "ra-quiz-page";
var _3 = "ra-quiz-page-vertical";
export { _1 as "quizPageActiveCls", _2 as "quizPageCls", _3 as "quizPageVerticalCls" }
